import React from "react";

const NotificationDotIcon = () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle id="badge" cx="7" cy="7" r="6" fill="#4548C4" stroke="white" strokeWidth="2"/>
</svg>;

export default NotificationDotIcon;
